import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/RenderCard.css';

const RenderCard = ({ render }) => {
  const { id, title, thumbnail, description, views, createdAt } = render;
  
  // Format the date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  
  // Truncate description if it's too long
  const truncateDescription = (text, maxLength = 75) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  };

  return (
    <Link to={`/render/${id}`} className="render-card">
      <div className="render-thumbnail">
        <img 
          src={thumbnail} 
          alt={title} 
          loading="lazy" 
        />
        <div className="view-count">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
          <span>{views}</span>
        </div>
      </div>
      
      <div className="render-info">
        <h3 className="render-title">{title}</h3>
        <p className="render-description">{truncateDescription(description)}</p>
        <div className="render-meta">
          <span className="render-date">{formatDate(createdAt)}</span>
        </div>
      </div>
    </Link>
  );
};

export default RenderCard;